export default __webpack_public_path__ + "static/noun_Money making_2324432-29590e54ef4f593a0996832fa2197aa5.svg";